import { routes } from '@/app/routing/router'
import { StarterPackPage } from './view'

const currentRoute = routes.starterPack

const StarterPackRoute = {
  route: currentRoute,
  view: StarterPackPage,
}

export { currentRoute, StarterPackRoute }
